import React, { Fragment, useState } from "react";

import { Divider } from "@mui/material";

//components
import CorreosClientes from "./Contactos/CorreosClientes";
import DireccionesClientes from "./Contactos/DireccionesClientes";
import TelefonosClientes from "./Contactos/TelefonosClientes";
import PaisesPerfil from "./TipoCIF/PaisesPerfil";

import {
  mostrarDialogoEliminarGenerico,
  DialogoEliminarGenerico,
} from "../../ControlUsuario/DialogoEliminarGenerico";

const Contactos = ({
  deviceIs = "DESKTOP",
  DatosContactoInfo,
  SectionsEnable,
}) => {
  const [registroEliminar, setRegistroEliminar] = useState({
    registroName: "",
    fuctionName: null,
  });

  function EstablecerRegistroEliminar(registroName, fuctionName) {
    setRegistroEliminar({
      registroName: registroName,
      fuctionName: fuctionName,
    });

    mostrarDialogoEliminarGenerico();
  }

  return (
    <Fragment>
      {SectionsEnable.some((x) => x.code === "AddressCIF") ? (
        <div style={{ padding: "0px", margin: "0px", width: "100%" }}>
          <DireccionesClientes
            deviceIs={deviceIs}
            DatosContactoInfo={{
              ...DatosContactoInfo,
              ElimenarRegistro: EstablecerRegistroEliminar,
            }}
          />
          <Divider style={{ margin: "20px 0px" }} />
        </div>
      ) : null}

      {SectionsEnable.some((x) => x.code === "PhoneContactCIF") ? (
        <div style={{ padding: "0px", margin: "0px", width: "100%" }}>
          <TelefonosClientes
            deviceIs={deviceIs}
            DatosContactoInfo={{
              ...DatosContactoInfo,
              ElimenarRegistro: EstablecerRegistroEliminar,
            }}
          />
          <Divider style={{ margin: "20px 0px" }} />
        </div>
      ) : null}

      {SectionsEnable.some((x) => x.code === "EmailContactCIF") ? (
        <div style={{ padding: "0px", margin: "0px", width: "100%" }}>
          <CorreosClientes
            deviceIs={deviceIs}
            DatosContactoInfo={{
              ...DatosContactoInfo,
              ElimenarRegistro: EstablecerRegistroEliminar,
            }}
          />
          <Divider style={{ margin: "20px 0px" }} />
        </div>
      ) : null}

      {SectionsEnable.some((x) => x.code === "NationalityCIF") ? (
        <div style={{ padding: "0px", margin: "0px", width: "100%" }}>
          <PaisesPerfil
            deviceIs={deviceIs}
            DatosContactoInfo={{
              ...DatosContactoInfo,
              ElimenarRegistro: EstablecerRegistroEliminar,
            }}
          />
        </div>
      ) : null}

      <DialogoEliminarGenerico
        deviceIs={deviceIs}
        id="Eliminar-InformacionContacto"
        TextoElementoEliminar={registroEliminar.registroName}
        funcionEliminar={registroEliminar.fuctionName}
      />
    </Fragment>
  );
};

export default Contactos;
